export default "__VITE_ASSET__25799d6a__"